const DEFAULT_SUB_DOMAIN: Readonly<string> = 'www';
const CONSENT_SUBDOMAIN_NAME: Readonly<string> = 'consent_subdomain';

const getUrlParameter = (location: string): string => {
  const name = CONSENT_SUBDOMAIN_NAME.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(location);
  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const GetConsentSubDomain = (): string => getUrlParameter(window.location.href) ?? DEFAULT_SUB_DOMAIN;

export { GetConsentSubDomain };